import { Container, Row } from 'react-bootstrap';
import React from 'react';
import CompetenciesDetail from '../shared/results/competencies-detail';

function LeaderCompetenciesSummary({ candidate }) {
  return (
    <>
      <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
        <>
          <Row className="justify-content-center pt-4">Competencies Summary</Row>
          <Row className="justify-content-center w-25 mx-auto pt-3">
            <hr style={{ borderTop: '2px solid' }} />
          </Row>
          <Row className="w-100 mx-auto pt-1">
            {candidate.raterCompetencies?.scores ? (
              <div className="text-center">
                This section of the report is a summary of the Hutrics Competency Assessment which includes stakeholder
                assessment of key competencies. The total number of raters that completed the assessments was:{' '}
                {candidate.raters.submitted}.
              </div>
            ) : (
              <div className="text-center">
                This section of the report is a summary of the Hutrics Competency Assessment.
              </div>
            )}
          </Row>
          <CompetenciesDetail candidate={candidate} />
        </>
      </Container>
    </>
  );
}

export default LeaderCompetenciesSummary;
